/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/dist/client/router';
import { addToCart, cartSelector } from '../../../store/feature/cartSlice';
import { authSelector } from '../../../store/feature/authSlice';
import { Listing_text } from '../../../constant/Translation/Listing';
import { push_data_layer } from '../../../constant/GTMDatalayer';
import axios from 'axios';
import { TYPE_CONSTANT } from '../../../constant/Web_constant';
import SidePan from '../../Shared/Modal/SidePan';
import { listingDetails } from '../../../store/feature/listingSlice';
import CheckoutPageLayout from '../../../themes/blank/CheckoutPageLayout';
import { get_dynamic_styles_with_default_value } from '../../../constant/DynamicStylesWithDefaultValue';
import { CardBoxDefaultStyles } from '../../../constant/default_styles/ProductDetailsStyles';
import Cookies from 'js-cookie';
const AppointmentButton = ({
  listing_details,
  selectedVariant,
  setError_message,
  setShowError,
  styles,
}) => {
  const { login } = useSelector(authSelector);
  const { isFetching } = useSelector(cartSelector);
  const router = useRouter();
  const dispatch = useDispatch();
  const { cart_details } = useSelector(cartSelector);

  const [sidePanOpen, setSidePanOpen] = useState(false);

  const isSellerListing =
    Cookies.get(`${TYPE_CONSTANT.DOMAIN}_storeAccountID`) ==
    listing_details?.account?.id;

  // add to cart
  const add_to_Cart = (e) => {
    if (
      TYPE_CONSTANT.LISTINGS_CONFIGS?.enable_stock &&
      listing_details?.stock == 0
    ) {
      setShowError(true);
      setError_message(Listing_text.product.out_of_stock);
      return false;
    }

    const cartData = {
      cart: {
        listing_id: listing_details?.id,
        quantity: 1,
        uuid: TYPE_CONSTANT.UUID,
      },
    };

    if (selectedVariant !== null) {
      cartData.cart['variant_id'] = selectedVariant;
    }
    dispatch(addToCart({ data: cartData })).then((res) => {
      if (!res.payload.code) {
        push_data_layer({
          event: 'booknow',
          data: {
            name: listing_details?.title,
            slug: listing_details?.slug,
            price: listing_details?.offer_price.amount,
            stock: listing_details?.stock,
            category: {
              id: listing_details?.categories?.[0]?.id,
              name: listing_details?.categories?.[0]?.name,
            },
            image: listing_details?.images,
            url: window.location.href,
          },
        });
        dispatch(
          listingDetails({
            ...router?.query,
          })
        );
        handleSidepanOpen(e);
      } else {
        if (res.payload.code === 489) {
          clear_cart(e);
        } else {
          setShowError(true);
          setError_message(res.payload.message);
        }
      }
    });
  };

  // clear cart
  const clear_cart = (e) => {
    if (cart_details && cart_details?.length > 0) {
      axios
        .delete('/api/cart/delete_all_cart')
        .then((res) => {
          add_to_Cart(e);
        })
        .catch((error) => {
          setShowError(true);
          setError_message(error?.response?.data?.message);
        });
    } else {
      add_to_Cart(e);
    }
  };

  //handleSidepanOpen
  const handleSidepanOpen = (e) => {
    e.stopPropagation();
    setSidePanOpen(true);
  };

  return (
    <>
      <div
        className=" w-full flex justify-center items-center"
        style={get_dynamic_styles_with_default_value(
          styles?.box_styles,
          CardBoxDefaultStyles
        )}
      >
        <button
          className={`  w-[95%]  h-[52px] bg-primary rounded-button flex justify-center items-center gap-3 ${
            isSellerListing &&
            TYPE_CONSTANT.LISTINGS_CONFIGS?.seller_can_place_order === false
              ? 'opacity-50 cursor-not-allowed'
              : ''
          }`}
          id="book_now"
          onClick={(e) => {
            if (
              isSellerListing &&
              TYPE_CONSTANT.LISTINGS_CONFIGS?.seller_can_place_order === false
            ) {
              setShowError(true);
              setError_message(Listing_text.product.seller_cant_place_order);
            } else {
              listing_details?.variants.length > 0
                ? selectedVariant == null
                  ? (setShowError(true), setError_message('Select one ticket'))
                  : clear_cart(e)
                : clear_cart(e);
            }
          }}
        >
          {isFetching ? (
            <svg
              className="animate-spin -ml-1 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <svg
              width="21"
              height="14"
              viewBox="0 0 21 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 5C7.23478 5 6.98043 5.10536 6.79289 5.29289C6.60536 5.48043 6.5 5.73478 6.5 6V8C6.5 8.26522 6.60536 8.51957 6.79289 8.70711C6.98043 8.89464 7.23478 9 7.5 9C7.76522 9 8.01957 8.89464 8.20711 8.70711C8.39464 8.51957 8.5 8.26522 8.5 8V6C8.5 5.73478 8.39464 5.48043 8.20711 5.29289C8.01957 5.10536 7.76522 5 7.5 5ZM19.5 6C19.7652 6 20.0196 5.89464 20.2071 5.70711C20.3946 5.51957 20.5 5.26522 20.5 5V1C20.5 0.734784 20.3946 0.48043 20.2071 0.292893C20.0196 0.105357 19.7652 0 19.5 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V5C0.5 5.26522 0.605357 5.51957 0.792893 5.70711C0.98043 5.89464 1.23478 6 1.5 6C1.76522 6 2.01957 6.10536 2.20711 6.29289C2.39464 6.48043 2.5 6.73478 2.5 7C2.5 7.26522 2.39464 7.51957 2.20711 7.70711C2.01957 7.89464 1.76522 8 1.5 8C1.23478 8 0.98043 8.10536 0.792893 8.29289C0.605357 8.48043 0.5 8.73478 0.5 9V13C0.5 13.2652 0.605357 13.5196 0.792893 13.7071C0.98043 13.8946 1.23478 14 1.5 14H19.5C19.7652 14 20.0196 13.8946 20.2071 13.7071C20.3946 13.5196 20.5 13.2652 20.5 13V9C20.5 8.73478 20.3946 8.48043 20.2071 8.29289C20.0196 8.10536 19.7652 8 19.5 8C19.2348 8 18.9804 7.89464 18.7929 7.70711C18.6054 7.51957 18.5 7.26522 18.5 7C18.5 6.73478 18.6054 6.48043 18.7929 6.29289C18.9804 6.10536 19.2348 6 19.5 6ZM18.5 4.18C17.9208 4.3902 17.4205 4.77363 17.0668 5.27816C16.7132 5.7827 16.5235 6.38388 16.5235 7C16.5235 7.61612 16.7132 8.2173 17.0668 8.72184C17.4205 9.22637 17.9208 9.6098 18.5 9.82V12H8.5C8.5 11.7348 8.39464 11.4804 8.20711 11.2929C8.01957 11.1054 7.76522 11 7.5 11C7.23478 11 6.98043 11.1054 6.79289 11.2929C6.60536 11.4804 6.5 11.7348 6.5 12H2.5V9.82C3.07915 9.6098 3.57954 9.22637 3.93316 8.72184C4.28678 8.2173 4.47648 7.61612 4.47648 7C4.47648 6.38388 4.28678 5.7827 3.93316 5.27816C3.57954 4.77363 3.07915 4.3902 2.5 4.18V2H6.5C6.5 2.26522 6.60536 2.51957 6.79289 2.70711C6.98043 2.89464 7.23478 3 7.5 3C7.76522 3 8.01957 2.89464 8.20711 2.70711C8.39464 2.51957 8.5 2.26522 8.5 2H18.5V4.18Z"
                fill="#FEFEFE"
              />
            </svg>
          )}
          <span className="   text-xl text-white font-semibold ltr:ml-7 rtl:mr-7 ">
            {Listing_text.product.book_appointment}
          </span>
        </button>
      </div>
      <SidePan
        id={`event-details-sidepan-${listing_details?.id}`}
        sidePanOpen={sidePanOpen}
        setSidePanOpen={setSidePanOpen}
        modal_section_styles={
          'fixed  right-0 left-0 bottom-0 lg:top-0 lg:my-auto   z-[60] overflow-hidden flex items-center  justify-center   rounded-t-[40px]   lg:rounded-card transform '
        }
        modal_inside_section_styles="bg-white rounded shadow-lg overflow-auto  max-w-full lg:max-w-5xl w-full max-h-full  lg:scrollbar-thin   lg:scrollbar-track-transparent  lg:scrollbar-thumb-transparent"
        modal_width={'max-w-xl w-full'}
        // close_function={() => {

        // }}
      >
        <div className=" relative max-h-[75vh]">
          <button
            className=" fixed  lg:hidden  ltr:right-3 rtl:left-3 w-10 h-10 flex items-center justify-center top-3 p-3 rounded-full shadow-md bg-white  z-40 text-primary"
            onClick={() => {
              setSidePanOpen(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-8 h-8"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          {sidePanOpen && <CheckoutPageLayout type={'appointments'} />}
        </div>
      </SidePan>
    </>
  );
};

export default AppointmentButton;
